import {
  BooleanInput,
  Edit,
  ReferenceInput,
  SelectInput,
  SimpleForm,
  TextInput,
  required,
} from 'react-admin'
import { Permission } from '../../components'
import { PERMISSIONS } from '../../constants'

export default props => (
  <Edit {...props} title="Editar permissão">
    <SimpleForm sx={{ maxWidth: 600 }}>
      <TextInput source="name" label="Nome" InputProps={{ autoComplete: 'off' }} validate={required()} sx={{ minWidth: 300 }} />
      <TextInput source="label" label="Descrição" InputProps={{ autoComplete: 'off' }} validate={required()} sx={{ minWidth: 300 }} />
      <ReferenceInput
        source="groupId"
        reference="permission-groups"
        sort={{ field: 'name', order: 'ASC' }}
        perPage={null}>
        <SelectInput
          label="Grupo"
          optionText="name"
          sx={{ minWidth: 300 }} />
      </ReferenceInput>
      <Permission permission={PERMISSIONS.ADMIN_PROFILE}>
        <>
          <BooleanInput source="isAdmin" label="Apenas para usuário Admin" />
          <BooleanInput source="isHomologation" label="Em homologação" />
        </>
      </Permission>
    </SimpleForm>
  </Edit>
)
